import React from 'react';
import Toast, {
  ToastProps,
} from '@ordermentum/ui-shared/components/Toast/Toast.deprecated';

export type NotificationProps = {
  details: {
    notificationTitle?: ToastProps['notificationTitle'];
    notificationType: ToastProps['notificationType'];
    notificationPayload: ToastProps['content'];
  };
  handleHide: () => void;
};

export const Notification = ({ details, handleHide }: NotificationProps) => (
  <Toast
    notificationType={details.notificationType}
    content={details.notificationPayload}
    handleHide={handleHide}
    notificationTitle={details.notificationTitle}
  />
);

export default Notification;
